import { useEffect, useState } from 'react';
import Card from '../components/card/Card';
import Button from '../components/button/Button';
import H from '../components/texts/h/H';
import { useNavigate } from 'react-router-dom';
import TableSkeleton from '../components/TableSkeleton/TableSkeleton';
import { adjustWidthTable, formatCuit } from '../utils/Masks';
import P from '../components/texts/p/P';
import { COLUMNS_TABLE_WIDTH, USERS_COLUMN_TABLE_WIDTH } from '../utils/Constants';
import Table from '../components/table/table';
import Image from '../components/image/Image';
import { ITableData } from '../types/interfaces';
import { getUsers } from '../services/UserService';
import { hasData } from '../utils/Utils';


interface IrowUser {
  ci: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;

}

const Users = () => {
  const navigate = useNavigate();
   const [isSearching, setIsSearching] = useState<boolean>(false);
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [users, setUsers] = useState<IrowUser[]>([]);
   const [tableData, setTableData] = useState<ITableData>();
   const [page, setPage] = useState<number>(0);

   useEffect(() => {
       setIsLoading(true);
       getUsers(page, 10)
         .then((response) => {
          if (hasData(response) && response.data?.content) {
            setUsers(response.data?.content);
            setTableData({
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              size: response.data.size,
              page: response.data.page,
            });
            setIsLoading(false);
         }}
        )
      },[page])

   const columns =[
    {name: 'CUIT', selector:  (row: IrowUser) => (
            <Card >
              <P type='3' variant='neutral'>
                {formatCuit(row?.ci || '')}
              </P>
            </Card>
          ), width: adjustWidthTable(USERS_COLUMN_TABLE_WIDTH, 0)
    },
    {name: 'Nombre y apellido', selector:  (row: IrowUser) => (
            <Card >
              <P type='3' variant='neutral'>
                {(row?.firstName || '')+' ' + (row?.lastName || '')}
              </P>
            </Card>
          ), width: adjustWidthTable(USERS_COLUMN_TABLE_WIDTH, 0)
    },
     {name: 'email', selector:  (row: IrowUser) => (
            <Card >
              <P type='3' variant='neutral'>
                {row?.email || ''}
              </P>
            </Card>
          ), width: adjustWidthTable(USERS_COLUMN_TABLE_WIDTH, 0)
    },
    {name: 'Rol', selector:  (row: IrowUser) => (
            <Card >
              <P type='3' variant='neutral'>
                {row?.role || ''}
              </P>
            </Card>
          ), width: adjustWidthTable(USERS_COLUMN_TABLE_WIDTH, 0)
    },
   ]

   const handleChangePage = (data: number) => {
    if (data < 0 || data === tableData?.totalPages) {
      return;
    }
    setPage(data);
  };
  return (
    <Card
      variant='neutral'
      modifier='inverted'
      spacing={'4'}
      height='-webkit-fill-available'
      width='54vw'
    >
      <Card display='flex' justifyContent='space-between' alignItems='center'>
        <Card display='flex' gap='16px' alignItems='center'>
          <H type='1' weight='bold' modifier='strong'>
            Usuarios
          </H>
        </Card>
        <Button
          variant='primary'
          size='lg'
          onClick={() => navigate('/usuarios/nuevousuario')}
        >
          Alta de nuevo usuario
        </Button>
      </Card>
      {isLoading ? (
              <Card margin={{ top: '4' }}>
                <TableSkeleton rows={10} columns={columns.length} />
              </Card>
            ) : users.length > 0 ? (
              <Card margin={{ top: '4' }} justifyContent='center' alignItems='center'>
                <Table
                  columns={columns}
                  data={users}
                  tableData={tableData}
                  handleChangePage={(e: any) => handleChangePage(e)}
                 
                />
              </Card>
            ) : (
              <Card
                display='grid'
                justifyContent='center'
                margin={{ top: '11', bottom: '11' }}
                width='53vw'
              >
                <Card display='flex' justifyContent='center' margin={{ bottom: '2' }}>
                  <Image name='folder_empty' />
                </Card>
                <P variant='primary' align='center' withMargin={false} weight='bold'>
                  No hay usuarios creados.
                </P>
                <P variant='primary' align='center'>
                  Podés crear un nuevo usuario.
                </P>
                <Button variant='primary' onClick={() => navigate('/usuarios/nuevousuario')}>
                  Alta de nuevo usuario
                </Button>
              </Card>
            )}
    </Card>
  );
};

export default Users;
